export default __webpack_public_path__ + "static/media/success-tick.d4866770.svg";